import React, { ReactNode } from 'react';

import {
  ProgressBarContainerProps,
  SimpleProgressBarProps,
  ProgressBarContainer,
  ProgressBarBox,
  SimpleProgressBar
} from './StyledProgressBar';

export type ProgressBarProps = SimpleProgressBarProps &
  ProgressBarContainerProps & {
    icon?: ReactNode;
    withNumber?: boolean;
    disabled?: boolean;
    detailCampaign?: boolean;
  };

const ProgressBar = (props: ProgressBarProps) => {
  const {
    color,
    inactive,
    icon,
    percentage,
    withNumber,
    disabled = false,
    detailCampaign = false
  } = props;

  return (
    <ProgressBarBox disabled={!detailCampaign ? false : disabled}>
      {icon}

      <ProgressBarContainer inactive={inactive}>
        <SimpleProgressBar percentage={percentage} color={color} />
      </ProgressBarContainer>

      {withNumber && (
        <span className="progress-bar-number">
          {!detailCampaign || !disabled
            ? `${parseFloat(percentage).toFixed()}%`
            : 'N/A'}
        </span>
      )}
    </ProgressBarBox>
  );
};

ProgressBar.defaultProps = {
  color: 'grey'
};

export default ProgressBar;
